import { URLS } from "constants/urls";
import apiRequests from "utils/apiRequests";

export const fetchSession = (refresh = false) =>
  apiRequests.get(`${URLS.GET_SESSION}?refresh=${refresh}`);
